export const setImageSrc = (id, src) => {
  const el = document.getElementById(id);
  if (el && src) {
    el.src = src;
  }
  return el;
};

export const q = (selector) => document.querySelector(selector);
export const qa = (selector) => Array.from(document.querySelectorAll(selector));

export const toggleClass = (el, className, isOn) => {
  if (!el) return;
  if (isOn) {
    el.classList.add(className);
  } else {
    el.classList.remove(className);
  }
};

export const setDisplay = (el, value) => {
  if (!el) return;
  el.style.display = value;
};

export const setBlur = (elements = [], value = 0) => {
  elements.forEach((el) => {
    if (!el) return;
    el.style.filter = value ? `blur(${value}px)` : "";
  });
};

export const clearInput = (el) => {
  if (el) {
    el.value = "";
  }
};

export const resetErrorField = (field, errorNode) => {
  if (errorNode) errorNode.innerText = "";
  if (field) field.style.border = "none";
};



